import React from "react"

const Link_arrow = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M26.4 5.1L2.55 28.95C2.25 29.25 1.9 29.4 1.5 29.4C1.1 29.4 0.75 29.25 0.45 28.95C0.15 28.65 0 28.3 0 27.9C0 27.5 0.15 27.15 0.45 26.85L24.3 3H11.1C10.675 3 10.3188 2.85542 10.0312 2.56625C9.74375 2.27705 9.6 1.91872 9.6 1.49125C9.6 1.06375 9.74375 0.708333 10.0312 0.425C10.3188 0.141667 10.675 0 11.1 0H27.9C28.325 0 28.6812 0.14375 28.9688 0.43125C29.2563 0.71875 29.4 1.075 29.4 1.5V18.3C29.4 18.725 29.2554 19.0813 28.9663 19.3687C28.6771 19.6562 28.3187 19.8 27.8913 19.8C27.4638 19.8 27.1083 19.6562 26.825 19.3687C26.5417 19.0813 26.4 18.725 26.4 18.3V5.1Z"
          fill="white"
        />
      </svg>
    </>
  )
}

export default Link_arrow
